// sapi-admin/src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Users from "./pages/Users";
import CouponManager from "./pages/CouponManagement/CouponManager";
import BannerManager from "./pages/BannerManagement/BannerManager";
import AnnouncementManager from "./pages/AnnouncementManagement/AnnouncementManager";
import Orders from "./pages/Orders";
import Login from "./pages/Login";
import AdminHome from "./pages/AdminHome";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import PiStores from './pages/PiStores/PiStores';
import ShippingSettings from "./pages/Settings/ShippingSettings";
import Products from "./pages/Products";
import EneoTransactions from "./pages/EneoTransactions";
import PiSellRequestsManager from "./pages/PiSellRequestsManager";
import AdminNotifications from "./pages/AdminNotifications";
import AdminProfile from "./pages/AdminProfile";
import { SoundProvider } from './contexts/SoundContext';
import WhatsAppAdmin from './pages/WhatsAppAdmin';
import DeliveryTracking from "./pages/DeliveryTracking";
import OperatorAccounts from "./pages/OperatorAccounts";
import RateSettings from "./pages/RateSettings";
import PageNotFound from "./pages/PageNotFound";

const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0a0f1e]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-amber-500"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/404" element={<PageNotFound />} />
      <Route path="/page-not-found" element={<PageNotFound />} />

      <Route
        path="/"
        element={
          user ? (
            <ProtectedRoute requiredRole="Admin">
              <AdminHome />
            </ProtectedRoute>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route index element={<AdminHome />} />

        <Route path="orders" element={<Orders />} />
        <Route path="users" element={<Users />} />
        <Route path="products" element={<Products />} />
        <Route path="coupons" element={<CouponManager />} />
        <Route path="banners" element={<BannerManager />} />
        <Route path="pi-stores" element={<PiStores />} />
        <Route path="eneo-transactions" element={<EneoTransactions />} />
        <Route path="pi-sell-requests" element={<PiSellRequestsManager />} />
        <Route path="announcements" element={<AnnouncementManager />} />
        <Route path="whatsapp" element={<WhatsAppAdmin />} />
        <Route path="shipping-settings" element={<ShippingSettings />} />
        <Route path="notifications" element={<AdminNotifications />} />
        <Route path="profile" element={<AdminProfile />} />
        <Route path="delivery-tracking" element={<DeliveryTracking />} />
        <Route path="operator-accounts" element={<OperatorAccounts />} />
        <Route path="rate-settings" element={<RateSettings />} />
      </Route>

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <SoundProvider>
        <Router>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
          <AppRoutes />
        </Router>
      </SoundProvider>
    </AuthProvider>
  );
}

export default App;